import {injectable} from 'inversify-props';

import {ISettingsProvider} from '@/services/settings/ISettingsProvider';
import {IGatewaySettingsService} from '@/services/settings/IGatewaySettings.service';
import {Setting} from '@/services/settings/Settings.types';

@injectable()
export class GatewaySettingsService implements IGatewaySettingsService, ISettingsProvider {

  public set(setting: Setting, value: any): void {
    throw new Error('not implemented');
  }

  public get(setting: Setting): any | null {
    return '';
  }

  public clear(setting: Setting): void {
    throw new Error('not implemented');
  }
}
